import React from 'react';
import { ListColumn, FooterOptions } from '../Datalist/Datalist'; // Import your Datalist component
import Datalist from '../Datalist/Datalist';
import './FilePickerTable.scss';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faTrash } from '@fortawesome/free-solid-svg-icons';

interface FilePickerTableProps {
    files: File[];
    onRemoveFile(file:File):void;
    isLoading: boolean;
}

const FilePickerTable: React.FC<FilePickerTableProps> = ({ files, onRemoveFile, isLoading }) => {

    const navigate = useNavigate(); // Use the navigate hook for navigation

    // Define the columns for the Invoice table
    const columns: ListColumn<File>[] = React.useMemo(() => [
        {
            key: 'name',
            fieldName: 'name',
            name: 'Namn',
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: File) => item.name,
            footer: (items: File[]) => `Antal: ${items.length}`,
        },
        // {
        //     key: 'type',
        //     fieldName: 'type',
        //     name: 'Typ',
        //     minWidth: 150,
        //     isActive: true,
        //     sorting: true, // Enable sorting
        //     onRender: (item: File) => item.type,
        // },
        {
            key: 'size',
            fieldName: 'size',
            name: 'Storlek',
            maxWidth: 100,
            minWidth: 50,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: File) => (item.size / 1024 > 9900)? `${(item.size / 1024 / 1024).toFixed(0)} MB` : `${(item.size / 1024).toFixed(0)} KB`
        },
        {
            key: '',
            fieldName: '',
            name: '',
            maxWidth: 50,
            minWidth: 50,
            isActive: true,
            sorting: false, // Enable sorting
            onRender: (item: File) => <button className="removeButton button-danger" onClick={() => onRemoveFile(item)}><FontAwesomeIcon icon={faTrash} /></button>,
        },
    ], [files]);

    return (
        <div className="customer-table-wrapper" style={{ maxHeight: '600px', overflowY: 'auto' }}>
            {/* Use the Datalist component */}
            <Datalist
                items={files}
                isLoading={isLoading}
                columns={columns}
                setColumns={(updatedColumns: ListColumn<File>[]) => {}}
                initialSortKey="name"  // Set default sort column
                descendingSort={true}    // Set default sort order to descending (most recent first)
                noItemsText="Inga filer valda"
                uniqueKey="name"  // Use 'invoiceNumber' as the unique key
            />
        </div>
    );
};

export default FilePickerTable;
